import { gql } from "@apollo/client";

const GET_ORDERS = gql`
  query GetOrders(
    $params: QueryParams
    $client: QueryOperators
    $status: QueryOperators
    $location: QueryOperators
    $excludeStatus: QueryOperators
  ) {
      orders(params: $params
      client: $client
      status: $status
      location: $location
      excludeStatus: $excludeStatus
    ) {
      info {
        count
      }
      results {
        id
        location{
          id
          name
        }
        status
        price
        updatedAt
        reference
        lineItems {
          product {
            id
            title
            img
            price
            description
            isPrimaryVariant
            product {
              id
              name
              description # Fetch nested product description
            }
          }
          qty
        }
        client {
          user {
            firstName
            lastName
          }
        }
      }
    }
  }
`;

const GET_LOCATIONS = gql`
  query getLocations($params: QueryParams, $name: String) {
    locations(params: $params, name: $name) {
      info {
        count
      }
      results {
        id
        name
      }
    }
  } 
`;

const GET_ORDER = gql`
  query GetOrder($id: ID!) {
    order(id: $id) {
      id
      status
      price
      updatedAt
      reference
      dropOffTime
      pickupTime
      lineItems {
        product {
          id
          title
          img
          price
          description
          isPrimaryVariant
          product {
            id
            name
            description # Fetch nested product description
          }
        }
        qty
      }
      events {
        type
        description
        changedAt
      }
      location {
        id
        name
        img
      }
      client {
        user {
          firstName
          lastName
        }
      }
      payment {
        id
        status
        createdAt
        paymentMethod {
          id
          last4
          brand
          type
        }
      }
    }
  }
`;

const GET_CLIENTS = gql`
  query GetClients($params: QueryParams, $search: String) {
    clients(params: $params, search: $search) {
      results {
        id
        user {
          firstName
          lastName
        }
      }
    }
  }
`;

export { GET_ORDERS, GET_CLIENTS, GET_ORDER, GET_LOCATIONS };
